module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAjCAMAAAA3znPYAAAASFBMVEUAAADU5//U5//U5//U5//V5//V5//U5//T6P/U6P/U5//V6P/T5//U5v/U5//T6f/U5//T5//U5//U5//T5//U6P/T5//U5//49UHfAAAAF3RSTlMA4SLqg9iFlSwqim8mGpQX5ZbAeHVYQHsWOSAAAACfSURBVDjLxdXZCoQwDAXQjjNmNvct//+nQn24lETqBcU8loPYNL0NW40STNVDEdyaVMXgUh/FDgYHVpf/NdbLYPAEG95GDG4xODA4MDiwzxu1/PvUe/g74T+PVxTvcvxD8qM/I+D+VnvTmTN5mfAlrs3J2sB9G5jYJtETot/EWRJzQs0gNd/XYerO83liueSzClwyOUhlLGo8mN/c27ACGONC+rOrg78AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/righticon.png
// module id = Jj7Z
// module chunks = 1